// Centralized data for AxonPremium

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/process", label: "Our Process" },
  { to: "/sustainability", label: "Sustainability" },
  { to: "/contact", label: "Contact" },
];

export const STATS = [
  { value: "1,200+", label: "Hectares of farmland" },
  { value: "8,500", label: "Premium cattle capacity" },
  { value: "9", label: "Product categories" },
  { value: "14", label: "Export destinations" },
];

export const PILLARS = [
  {
    n: "01",
    name: "Dairy Manufacturing",
    desc: "Paneer, ghee, cheese, butter, yogurt, curd, ice cream and milk powder — all made on site for institutional and export buyers.",
    cta: "Explore Dairy",
    tab: "dairy",
    icon: "Drop",
  },
  {
    n: "02",
    name: "Pharma Crop Export",
    desc: "Pharmaceutical-grade Moringa, Ashwagandha, Curcumin and 15+ Ayurvedic herbs for pharma, nutraceutical and supplement manufacturers worldwide.",
    cta: "Explore Crops",
    tab: "pharma",
    icon: "Leaf",
  },
  {
    n: "03",
    name: "Cattle Breeding",
    desc: "Pedigree Girlando and indigenous buffalo breeds — sold to dairy farms, cooperatives and government livestock programs.",
    cta: "Explore Cattle",
    tab: "cattle",
    icon: "Cow",
  },
];

export const PILLAR_STATS = [
  {
    value: "0",
    label: "Litres of milk purchased externally",
    body: "Every drop we process comes from our own cattle, fed on our own crops.",
    accent: true,
  },
  {
    value: "17+",
    label: "Pharma-grade crop varieties grown in-house",
    body: "Moringa to Mulethi — cultivated to nutraceutical specification on our owned soil.",
  },
  {
    value: "2+",
    label: "Premium cattle breeds available for institutional sale",
    body: "Girlando crossbreed and indigenous buffalo — verified lots, full lineage.",
  },
];

export const INTEGRATED_MODEL = [
  {
    step: "01",
    title: "Owned Land",
    body:
      "Acquired tracts of fertile, chemical-free soil — the foundation of every batch we ship.",
  },
  {
    step: "02",
    title: "Moringa & Fodder",
    body:
      "Pharmaceutical-grade Moringa and proprietary fodder, cultivated in-house. Never purchased.",
  },
  {
    step: "03",
    title: "Premium Cattle",
    body: "Indigenous Gir, Sahiwal & high-yield imported breeds, raised on our own feed.",
  },
  {
    step: "04",
    title: "In-House Milk",
    body:
      "Milk is collected, chilled and routed within our own cold chain. No middlemen, no aggregation.",
  },
  {
    step: "05",
    title: "Value-Added Processing",
    body: "Paneer, ghee, cheese, butter, yogurt, curd, ice cream and milk powder — all made on site.",
  },
  {
    step: "06",
    title: "B2B & Export",
    body:
      "Shipped to restaurant groups, hotels, food manufacturers and distributors across 14 markets.",
  },
];

export const PRODUCTS = [
  {
    name: "Paneer",
    use: "Restaurant chains, ready-meal manufacturers",
    img: "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=1200&q=85",
    desc: "Firm, low-moisture paneer engineered for institutional kitchens.",
  },
  {
    name: "Ghee",
    use: "Premium retail private label, export",
    img: "https://images.pexels.com/photos/20689447/pexels-photo-20689447.jpeg?auto=compress&cs=tinysrgb&w=1200",
    desc: "Traditional Bilona-grade A2 ghee, hand-finished from cultured curd.",
    flagship: true,
  },
  {
    name: "Cheese",
    use: "Hospitality, QSR, food service",
    img: "https://images.unsplash.com/photo-1486297678162-eb2a19b0a32d?w=1200&q=85",
    desc: "Mozzarella, cheddar and processed slices — calibrated for melt and yield.",
  },
  {
    name: "Butter",
    use: "Bakeries, hotels, B2B distribution",
    img: "https://images.unsplash.com/photo-1589985270826-4b7bb135bc9d?w=1200&q=85",
    desc: "Cultured table butter and unsalted bakery butter, 82% fat minimum.",
  },
  {
    name: "Yogurt",
    use: "Hospitality, ready-to-eat brands",
    img: "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=1200&q=85",
    desc: "Set & stirred yogurts in customizable fat profiles and packaging.",
  },
  {
    name: "Curd",
    use: "Institutional, food service",
    img: "https://images.pexels.com/photos/773253/pexels-photo-773253.jpeg?auto=compress&cs=tinysrgb&w=1200",
    desc: "Traditional dahi with consistent acidity and shelf-life curve.",
  },
  {
    name: "Ice Cream",
    use: "HORECA, private label",
    img: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=1200&q=85",
    desc: "Premium dairy ice cream base with white-label flexibility.",
  },
  {
    name: "Milk Powder",
    use: "Food manufacturers, export bulk",
    img: "https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=1200&q=85",
    desc: "Skimmed and whole milk powder in 25kg export-grade bags.",
  },
];

// Pharma / herb image pool — reused across pharma crop cards
const HERB_POWDER = "https://images.pexels.com/photos/17820731/pexels-photo-17820731.jpeg?w=1200&q=85";
const HERB_LEAVES = "https://images.pexels.com/photos/27328342/pexels-photo-27328342.jpeg?w=1200&q=85";
const HERB_FIELD = "https://images.unsplash.com/photo-1757283961570-682154747d9c?w=1200&q=85";
const HERB_PLANT = "https://images.pexels.com/photos/10902685/pexels-photo-10902685.jpeg?w=1200&q=85";
const HERB_HUSK = "https://images.pexels.com/photos/35853926/pexels-photo-35853926.jpeg?w=1200&q=85";
const HERB_AMLA = "https://images.unsplash.com/photo-1676043966983-f5bd22435e64?w=1200&q=85";
const HERB_GILOY = "https://images.pexels.com/photos/12192276/pexels-photo-12192276.jpeg?w=1200&q=85";
const HERB_GAUR = "https://images.pexels.com/photos/5441094/pexels-photo-5441094.jpeg?w=1200&q=85";
const HERB_SENNA = "https://images.unsplash.com/photo-1758614307255-ebbb4b008d5f?w=1200&q=85";
const HERB_NEEM = "https://images.pexels.com/photos/28511113/pexels-photo-28511113.jpeg?w=1200&q=85";
const HERB_SARPGANDHA = "https://images.pexels.com/photos/13084889/pexels-photo-13084889.jpeg?w=1200&q=85";
const HERB_ADULSA = "https://images.pexels.com/photos/16062958/pexels-photo-16062958.jpeg?w=1200&q=85";
const HERB_ALOEVERA = "https://images.pexels.com/photos/12304752/pexels-photo-12304752.jpeg?w=1200&q=85";

const HERB_MORINGA = "https://images.unsplash.com/photo-1706061868304-a6f5ede72fcb?w=1200&q=85";
const HERB_TURMERIC = "https://images.unsplash.com/photo-1583949885751-23b7d1909378?auto=compress&cs=tinysrgb&w=1200";
const HERB_OIL = "https://images.unsplash.com/photo-1573461160327-b450ce3d8e7f?w=1200&q=85";
const HERB_MUSTERD = "https://images.unsplash.com/photo-1610547939489-73202bc6afda?w=1200&q=85";

export const PHARMA_CROPS = [
  { name: "Moringa Powder", grade: "Pharmaceutical Grade", use: "Multivitamin tablets · Malnutrition", img: HERB_MORINGA, flagship: true },
  { name: "Ashwagandha Powder", grade: "Nutraceutical", use: "Stress · Anxiety · Energy capsules", img: HERB_POWDER },
  { name: "Curcumin Extract", grade: "Pharma Grade", use: "Anti-inflammatory · Oncology research", img: HERB_TURMERIC },
  { name: "Psyllium Husk (Isabgol)", grade: "Export Grade", use: "Digestive health · Laxatives", img: HERB_HUSK },
  { name: "Brahmi & Shankhpushpi", grade: "Ayurvedic", use: "Brain tonic · Memory formulations", img: HERB_LEAVES },
  { name: "Safed Musli", grade: "Nutraceutical", use: "Vitality & strength supplements", img: HERB_PLANT },
  { name: "Amla Powder", grade: "Nutraceutical", use: "Vitamin C tablets · Immunity boosters", img: HERB_AMLA },
  { name: "Giloy / Guduchi Powder", grade: "Pharma Grade", use: "Antiviral · Fever · Ayurvedic research", img: HERB_GILOY},
  { name: "Neem Powder & Oil", grade: "Pharma Grade", use: "Antibacterial · Dermatological creams", img: HERB_NEEM },
  { name: "Guar Gum Powder", grade: "Pharma Excipient", use: "Tablet binding · Controlled release", img: HERB_GAUR },
  { name: "Senna Leaves", grade: "Export Grade", use: "Natural laxative base · EU exports", img: HERB_SENNA},
  { name: "Castor Oil", grade: "Pharma Grade", use: "Ointments · Skin creams · Laxatives", img: HERB_OIL },
  { name: "Sarpagandha", grade: "Pharma Grade", use: "Blood pressure formulations", img: HERB_SARPGANDHA},
  { name: "Vasaka / Adulsa", grade: "Pharma Grade", use: "Cough syrup · Respiratory medicine", img: HERB_ADULSA },
  { name: "Licorice / Mulethi", grade: "Pharma Grade", use: "Throat lozenges · Acidity medicine", img: HERB_FIELD },
  { name: "Aloe Vera Extract", grade: "Cosmeceutical", use: "Dermatology · Gel & cream products", img: HERB_ALOEVERA },
  { name: "Mustard Oil", grade: "Food & Industrial", use: "Food grade · Industrial applications", img: HERB_MUSTERD },
];

export const CATTLE_BREEDS = [
  {
    name: "Girlando Cow",
    use: "Dairy Farms · Cooperatives · Institutional",
    img: "https://images.pexels.com/photos/422218/pexels-photo-422218.jpeg?auto=compress&cs=tinysrgb&w=1200",
    desc: "High milk yield crossbreed (Gir × Holstein). Suited to Indian climate. Available in verified lots with full lineage records.",
    flagship: true,
  },
  {
    name: "Premium Buffalo",
    use: "Dairy Farms · Government Programs",
    img: "https://images.unsplash.com/photo-1756638447144-cfaa1dea21f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxhZ3JpY3VsdHVyZSUyMGZhcm0lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc4MTU4MzQ0fDA&ixlib=rb-4.1.0&q=85",
    desc: "High-fat milk yield indigenous buffalo. Selected for institutional dairy operations.",
  },
  {
    name: "More Breeds",
    use: "Coming 2026 — Register Interest",
    img: "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1200&q=85",
    desc: "Sahiwal, Gir purebred and high-yield imports in development. Reserve early lots through our trade team.",
    coming: true,
  },
];

export const INDUSTRIES = [
  {
    name: "Restaurant Chains",
    icon: "ForkKnife",
    desc: "Bulk paneer, ghee, butter and cheese on institutional spec.",
  },
  {
    name: "Hotels & Hospitality",
    icon: "Buildings",
    desc: "Banquet-grade dairy and private-label SKUs at scale.",
  },
  {
    name: "Food Manufacturers",
    icon: "Factory",
    desc: "Bulk butter, milk powder and ghee for industrial lines.",
  },
  {
    name: "Exporters & Distributors",
    icon: "Boat",
    desc: "Country-specific compliance, packaging and documentation.",
  },
  {
    name: "Government & Institutions",
    icon: "Bank",
    desc: "Mid-day meal programs, defence catering and PSU contracts.",
    featured: true,
  },
  {
    name: "Pharma & Nutraceutical Companies",
    icon: "Flask",
    desc: "Pharmaceutical-grade Moringa, Ashwagandha, Curcumin and 15+ herb extracts.",
  },
  {
    name: "Livestock & Dairy Farm Buyers",
    icon: "Cow",
    desc: "Premium Girlando crossbreed and indigenous buffalo for institutional operations.",
  },
];

export const CERTS = ["FSSAI", "ISO 22000", "AGMARK", "APEDA", "HACCP"];

export const DIFFERENTIATORS = [
  {
    title: "Pharmaceutical-grade feed",
    body:
      "Our Moringa is grown to a quality spec usually reserved for nutraceuticals — fed only to our cattle.",
  },
  {
    title: "Owned breed lineage",
    body:
      "Indigenous Gir & Sahiwal alongside high-yield imports. We control genetics, lifecycle and welfare.",
  },
  {
    title: "Zero outsourced milk",
    body:
      "Unlike co-operative models, we never aggregate milk from third-party farmers. One source. One spec.",
  },
  {
    title: "Export-ready infrastructure",
    body:
      "FSSAI, APEDA-aligned cold chain. Documentation and packaging tuned for institutional clients.",
  },
];

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1673200692829-fcdb7e267fc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGZhcm0lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc4MTU4MzQ0fDA&ixlib=rb-4.1.0&q=85",
  heroProduct:
    "https://images.unsplash.com/photo-1559561853-08451507cbe7?w=1600&q=85",
  cattle:
    "https://images.unsplash.com/photo-1596733430284-f7437764b1a9?w=1600&q=85",

  farm:
    "https://images.unsplash.com/photo-1569239591652-6cc3025b07fa?w=1600&q=85",
  moringa:
    "https://images.unsplash.com/photo-1706061868304-a6f5ede72fcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxtb3JpbmdhJTIwcGxhbnQlMjBsZWF2ZXMlMjBncmVlbnxlbnwwfHx8fDE3NzgxNTgzMDl8MA&ixlib=rb-4.1.0&q=85",
  cheese:
    "https://images.unsplash.com/photo-1775831954270-17db4d8bcb04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxhcnRpc2FuYWwlMjBjaGVlc2UlMjBkYWlyeSUyMHByb2R1Y3RzfGVufDB8fHx8MTc3ODE1ODMwOXww&ixlib=rb-4.1.0&q=85",
  ghee:
    "https://images.unsplash.com/photo-1606755962773-d324e0a13086?w=1600&q=85",
  logistics:
    "https://images.unsplash.com/photo-1650391581312-3bb8fdc67b2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHNoaXAlMjBsb2dpc3RpY3N8ZW58MHx8fHwxNzc4MTU4MzQ0fDA&ixlib=rb-4.1.0&q=85",
  facility:
    "https://images.unsplash.com/photo-1585428311604-98738fc5687a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxhZ3JpY3VsdHVyZSUyMGZhcm0lMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzc4MTU4MzQ0fDA&ixlib=rb-4.1.0&q=85",
  field:
    "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&q=85",
  herd:
    "https://images.unsplash.com/photo-1500595046743-cd271d694d30?w=1600&q=85",
  lab:
    "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=1600&q=85",
};
